import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { MortgageInsuranceDiscontinuanceCode, MortgageInsuranceEscrowSetting } from '../../loan/EscrowSetting';
import { zodBrandedString } from '../../utils';
import { dateIsTodayOrInThePast, DateString } from '../fields';

export const CancelMortgageInsuranceRow = z.object({
  ...MortgageInsuranceEscrowSetting.pick({ certificateId: true }).shape,
  loanId: zodBrandedString<LosId>(),
  cancellationDiscontinuanceCode: MortgageInsuranceDiscontinuanceCode,
  cancellationEffectiveDate: DateString.and(dateIsTodayOrInThePast),
});
export type CancelMortgageInsuranceRow = z.infer<typeof CancelMortgageInsuranceRow>;

export const CANCEL_MORTGAGE_INSURANCE_ROW_REQUIRED_FIELDS = Object.keys(CancelMortgageInsuranceRow.shape).filter(
  (key) => !CancelMortgageInsuranceRow.shape[key as keyof typeof CancelMortgageInsuranceRow.shape].isOptional(),
) as (keyof CancelMortgageInsuranceRow)[];
